import { useState, useEffect } from 'react';
import ready from './ready'

// The value (int) returned by useNewServiceWorker will change every time a new service worker has become active.
// This can be reacted to in order to refresh the page.
// Initial value is 0.
// Might be able to simplify this somewhat, seems like controllerChangeTrigger could be returned to the same effect
export default function useNewServiceWorker() {
  const [isControlled, setIsControlled] = useState(false)
  const [controllerChangeTrigger, setControllerChangeTrigger] = useState(0)
  const [newServiceWorkerTrigger, setNewServiceWorkerTrigger] = useState(0)

  useEffect(() => {
    detectController()
    const unregisterDetectControllerChanged = detectControllerChanged()

    // Remove the event listener when the component unmounts
    return () => {
      unregisterDetectControllerChanged()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isControlled) {
      setNewServiceWorkerTrigger(prev => prev + 1)
    }
    setIsControlled(!!navigator.serviceWorker?.controller)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controllerChangeTrigger])

  async function detectController() {
    ready().then(registration => {
      if (registration) {
        setIsControlled(!!navigator.serviceWorker?.controller)
      }
    })
  }

  function detectControllerChanged() {
    navigator.serviceWorker?.addEventListener('controllerchange', handleControllerChange);

    // Return deregister callback
    return () => {
      navigator.serviceWorker?.removeEventListener('controllerchange', handleControllerChange);
    }
  }

  function handleControllerChange() {
    setControllerChangeTrigger(prev => prev + 1)
  }

  return newServiceWorkerTrigger
}